import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from "@material-ui/core";
import moment from "moment";
import { RIDE_TYPES_RENDER } from "../utils/constants";

class ExcelImportErrors extends React.Component {
  _isMounted = false;

  state = null;

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _camelize = (field) =>
    field
      .match(/^[a-z]+|[A-Z][a-z]*/g)
      .map((str) => str[0].toUpperCase() + str.substr(1).toLowerCase())
      .join(" ");

  _getFieldName = (errorField) => {
    let fieldName = this._camelize(errorField);
    if (fieldName.includes("Datetime")) {
      fieldName = fieldName.replace("Datetime", " ").replace(/^/, "Ride Date ");
    }
    if (this._isItErrorMessage({ errorField, fieldName })) return errorField;
    return fieldName;
  };

  _isItErrorMessage({ errorField, fieldName }) {
    if (errorField.length > fieldName.length) return true;
  }

  _switchButton = (i) => {
    if (this.state && this.state[`showList${i}`]) {
      return (
        <Button
          onClick={() => this.setState({ [`showList${i}`]: false })}
          color="primary">
          Hide list
        </Button>
      );
    }
    return (
      <Button
        onClick={() => this.setState({ [`showList${i}`]: true })}
        color="primary">
        Open list
      </Button>
    );
  };

  render() {
    const { wrongExcelImportHistory } = this.props.record;
    const lastError =
      wrongExcelImportHistory.length > 0
        ? [wrongExcelImportHistory[wrongExcelImportHistory.length - 1]]
        : [];

    if (
      (!wrongExcelImportHistory || !wrongExcelImportHistory.length) &&
      !this._isMounted
    ) {
      return null;
    }

    return (
      <Card>
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>File name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Saved rides</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {[...lastError].map((error, i) => {
                return (
                  <React.Fragment key={i}>
                    <TableRow>
                      <TableCell>
                        {moment(error.createdAt).format("DD/MM/YYYY HH:mm")}
                      </TableCell>
                      <TableCell>
                        {<a href={error.link}>{error.fileName}</a>}
                      </TableCell>
                      <TableCell>
                        {RIDE_TYPES_RENDER[error.type.toLowerCase()]}
                      </TableCell>
                      <TableCell>{error.saveCount}</TableCell>
                      <TableCell>{this._switchButton(i)}</TableCell>
                    </TableRow>
                    {this.state &&
                      this.state[`showList${i}`] &&
                      error.unsaved.map((unsavedEL, j) => (
                        <React.Fragment key={j}>
                          <TableRow>
                            <TableCell colSpan={1} />
                            <TableCell colSpan={4}>
                              <b>Errors:</b>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell rowSpan={1} />
                            <TableCell colSpan={1}>
                              Number of row with error
                            </TableCell>
                            <TableCell colSpan={3}>Incorrect Field</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell rowSpan={1} />
                            <TableCell colSpan={1}>{`${
                              unsavedEL.numberOfRow
                            }`}</TableCell>
                            <TableCell colSpan={3}>
                              {" "}
                              {unsavedEL.errorFields.map(
                                (field) => `${this._getFieldName(field)}; `,
                              )}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  }
}

export default ExcelImportErrors;



// WEBPACK FOOTER //
// ./src/components/ExcelImportErrors.js